import type { User } from "@fitties/shared";
import { backendRegistry } from "@infrastructure/providers/backendRegistry";

// Factory function that creates auth service instances
export function createSharedService(dependencies = backendRegistry) {
  const { database } = dependencies;

  return {
    // Get user data from Document Database
    async getCurrentUser(userId: string): Promise<User | null> {
      return await database.getDocument("users", userId);
    },

    // Update current user
    async updateCurrentUser(userId: string, updates: Partial<User>): Promise<void> {
      return await database.updateDocument("users", userId, updates);
    },

    // Subscribe to user data changes
    subscribeToCurrentUser(userId: string, callback: (userData: User | null) => void): () => void {
      return database.subscribeToDocument("users", userId, callback);
    },
  };
}

// Export singleton instance using the factory
export const sharedService = createSharedService();
export default sharedService;
